import * as z from "zod";

function parseHttpsUrl(value: string): URL | undefined {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url : undefined;
  } catch {
    return undefined;
  }
}

/** An https URL, saved as its origin and path without a trailing slash. */
export function httpsBaseUrl(
  message: string,
  isAllowedHost: (hostname: string) => boolean = () => true,
) {
  return z
    .string()
    .trim()
    .transform((value, ctx) => {
      const url = parseHttpsUrl(value);
      if (!url || !isAllowedHost(url.hostname)) {
        ctx.addIssue({ code: "custom", message });
        return z.NEVER;
      }
      return `${url.origin}${url.pathname.replace(/\/+$/, "")}`;
    });
}
